import Vue from "vue";
import moment from "moment";
class Logger {
  LogType = { Error: "Error", Warning: "Warning" };
  storageName = "OOLoggerStorage";
  checkExistLocalStorage() {
    if (window.localStorage) return true;
    return false;
  }
  log(category, message, url, logType) {
    if (!this.checkExistLocalStorage()) return;

    if (process.env.NODE_ENV != "production") {
      console.log(category, message, url, logType);
    }

    let nowDate = moment();
    let value = JSON.parse(localStorage.getItem(this.storageName));
    if (value == null || value === undefined) value = {};
    let val = {
      category: category || "unknown",
      desc: message || "",
      path: url || "",
      logType: logType,
      dateCreated: nowDate.format("dd, DD MMM")
    };
    value[new Date().toTimeString()] = val;
    try {
      localStorage[this.storageName] = JSON.stringify(value);
    } catch (e) {
      alert("Error when writing to Local Storage\n" + e);
    }
    try {
      val.url = window.location.href;
      if (navigator.userAgent) val.userAgent = navigator.userAgent;
      switch (logType) {
        case this.LogType.Warning:
          Vue.rollbar.warning(JSON.stringify(val));
          break;
        case this.LogType.Error:
          Vue.rollbar.error(JSON.stringify(val));
          break;
        default:
          Vue.rollbar.info(JSON.stringify(val));
          break;
      }
    } catch (e) {
      alert("Error when writing to rollbar\n" + e);
    }
  }
  getLogData() {
    if (!this.checkExistLocalStorage()) return;
    let value = JSON.parse(localStorage.getItem(this.storageName));
    if (value == null || value === undefined) value = {};
    let arrayLog = [];
    for (var key in value) {
      value[key].dateTime = key;
      arrayLog.push(value[key]);
    }
    return arrayLog;
  }
  clearLog() {
    if (!this.checkExistLocalStorage()) return;
    let value = {};

    try {
      localStorage[this.storageName] = JSON.stringify(value);
    } catch (e) {
      alert("Error when writing to Local Storage\n" + e);
    }
  }
}
export const logger = new Logger();
